<template>
  <div class="more-detail-box" v-if="shopInfo">
    <DialogPopup
      width="450px"
      :show="floatingVisible"
      custom-class="more-detail-box-dialog"
    >
      <PageMbHeader
        title=""
        :iconClass="'icon-outline_close'"
        :posSticky="true"
        :transShow="false"
        :transOpen="false"
        @icon-click="closeFloat"
      />
      <ShopMoreDetails :title="shopInfo.shopName" :list="moreDatilList" />
    </DialogPopup>
    <DrawerPopup
      :show="drawerVisible"
      direction="btt"
      size="88%"
      :bottomShow="false"
      @close="closeH5Dialog"
    >
      <div class="detail-wrapper">
        <ShopMoreDetails :title="shopInfo.shopName" :list="moreDatilList" />
      </div>
    </DrawerPopup>
  </div>
</template>

<script>
import PageMbHeader from '@/components/PageMbHeader';
import DialogPopup from '@/components/DialogPopup';
import DrawerPopup from '@/components/DrawerPopup';
import ShopMoreDetails from '@/components/ShopMoreDetails';
import { mapState } from 'vuex';

export default {
  name: 'MoreDetailBox',
  components: {
    DrawerPopup,
    DialogPopup,
    PageMbHeader,
    ShopMoreDetails,
  },
  props: {
    show: Boolean,
    type: String,
  },
  computed: {
    ...mapState({
      isH5: ({ common }) => common.isH5,
      shopInfo: ({ store }) => store.shopInfo,
    }),
  },
  watch: {
    show(nVal) {
      this.init(nVal);
    },
    type(nVal, oVal) {
      if (nVal !== oVal) {
        this.infoInit();
      }
    },
    shopInfo(nVal) {
      this.infoInit(nVal);
    },
  },
  data() {
    return {
      floatingVisible: false,
      drawerVisible: false,
      moreDatilList: [],
    };
  },
  mounted() {
    this.init(this.show);
    this.infoInit(this.shopInfo);
  },
  methods: {
    init(val) {
      this.isH5 && (this.drawerVisible = val);
      !this.isH5 && (this.floatingVisible = val);
    },
    infoInit(val) {
      !val && (val = this.shopInfo);
      this.doBusiness = +val.cShopStatus === 1;
      this.setMoreDetails(val);
    },
    closeFloat() {
      this.floatingVisible = false;
      this.$emit('close');
    },
    closeH5Dialog() {
      this.drawerVisible = false;
      this.$emit('close');
    },
    goUrl() {
      this.info.redirectUrl && window.open(this.info.redirectUrl, '_blank');
    },
    setMoreDetails(val) {
      let moreDatilList = [];
      this.moreDatilList = [];
      // 营销活动  活动规则
      if (this.type === 'coupon') {
        let promotions = val?.actTipsDetails?.map((item) => {
          return {
            title: item.cTypeDesc,
            content: [
              {
                text: item.content,
              },
            ],
          };
        });
        promotions &&
          promotions.length &&
          moreDatilList.push({
            type: 'promotions',
            title: this.$t('活动'),
            icon: 'icon-outline_conpons',
            descList: promotions,
          });
      } else {
        // 地址
        val?.addr &&
          moreDatilList.push({
            type: 'address',
            title: this.$t('地址'),
            icon: 'icon-outlined_adress',
            descList: [
              {
                content: [
                  {
                    text: val.addr,
                  },
                ],
              },
            ],
          });
        // 营业状态 非营业状态 shopInfo.cShopStatus nextBizTimeDesc
        let arrNoBusiness = [2, 5];
        let businessTime = val?.bizDayTimeDesc?.map((item) => {
          return {
            title: item.bizDayDesc,
            content: item.bizTimeDesc.map((time) => {
              return { text: time };
            }),
          };
        });
        let timeItem = {
          type: 'businessTime',
          title: this.$t('营业时间'),
          icon: 'icon-outlined_history',
          descList: businessTime,
        };
        if (arrNoBusiness.includes(+val?.cShopStatus)) {
          timeItem.title = this.$t('休息中');
          timeItem.descList = [
            {
              content: [
                {
                  text: this.$sprintf(
                    this.$t('开始营业%s'),
                    val?.nextBizTimeDesc
                  ),
                },
              ],
            },
          ];
          businessTime &&
            timeItem.descList.push(
              {
                title: this.$t('营业时间'),
              },
              ...businessTime
            );
          moreDatilList.push(timeItem);
        } else {
          businessTime && moreDatilList.push(timeItem);
        }
        // 配送信息 deliveryType
        let deliveryMap = {
          1: this.$t('FoodC_education_Platform_Delivery_MJPQ'),
          2: this.$t('商家自配送'),
        };
        // this.doBusiness &&
        val?.deliveryType &&
          moreDatilList.push({
            type: 'deliveryType',
            title: this.$t('配送方式'),
            icon: 'icon-filled_delivery',
            descList: [
              {
                content: [
                  {
                    text: deliveryMap[val.deliveryType] || '',
                  },
                ],
              },
            ],
          });
        // 联系方式 phone  '1,2'
        let phoneList = val?.phone?.split(',')?.map((item) => {
          return {
            text: item,
          };
        });
        val?.phone &&
          moreDatilList.push({
            type: 'telephone',
            title: this.$t('商家联系方式'),
            icon: 'icon-outline_phone',
            descList: [
              {
                content: phoneList,
              },
            ],
          });
        // 支付方式 仅巴西可见 shopPayDesc
        let payList = val?.shopPayDesc?.map((item) => {
          return {
            title: item.title,
            content: (item.cardDesc || []).map((time) => {
              return { text: time };
            }),
          };
        });
        payList &&
          moreDatilList.push({
            type: 'payment',
            title: this.$t('支付方式'),
            icon: 'el-icon-wallet',
            descList: payList,
          });
        // 特定商取引法 仅日本可见 disclaimer
        val?.disclaimer &&
          moreDatilList.push({
            type: 'notification',
            title: this.$t('法规'),
            icon: 'icon-outlined_rule',
            descList: [
              {
                content: [
                  {
                    text: val.disclaimer.desc,
                    viewName: this.$t('更多'),
                    viewUrl: val.disclaimer.url,
                  },
                ],
              },
            ],
          });
      }
      // 处理 分组下划线的问题
      let showGroup = [
        ['promotions'],
        ['address', 'businessTime', 'deliveryType', 'telephone'],
        ['payment'],
        ['notification'],
      ];
      let n = 0;
      moreDatilList.reduce((item1, item2) => {
        let arr = showGroup[n];
        if (item1) {
          if (!arr.includes(item1.type)) {
            n++;
            arr = showGroup[n];
          }
          item1.noContainer = !(
            arr.includes(item1.type) && !arr.includes(item2?.type)
          );
          !item1.noContainer && n++;
        }
        return item2;
      }, null);
      this.moreDatilList = moreDatilList;
    },
  },
};
</script>
<style lang="scss">
.more-detail-box-dialog {
  .mobile-popup-wrapper {
    border-radius: rem(24) rem(24) 0 0;
    background: #fff;
  }
  .content-scroll-wrapper {
    background: #fff;
  }
  .el-dialog__body {
    background: #fff !important;
  }
}
</style>
<style lang="scss" scoped>
@media screen and (max-width: 768px) {
  .detail-wrapper {
    height: calc(80vh - 15px);
  }
}
</style>
